module.exports = __webpack_public_path__ + "static/media/grey-button-landing.7af16992.png";